const missionPoints = [
  "Continuously improving the standards and quality of our services.",
  "Constantly striving to exceed each client's expectations.",
  "Maintaining our dedication to the highest moral and professional principles.",
  "Providing a challenging and secure environment for our people.",
];

export default function AboutMission() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">

        {/* Section header */}
        <div className="text-center mb-14">
          <span className="text-cyan-600 text-xs font-semibold uppercase tracking-widest">What drives us</span>
          <h2 className="text-gray-900 text-4xl font-extrabold uppercase tracking-tight mt-3">
            Mission, Ethos &amp; Policy
          </h2>
          <div className="w-16 h-1 bg-cyan-500 rounded-full mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Mission */}
          <div className="bg-white rounded-lg p-8 border border-gray-100">
            <div className="w-12 h-12 flex items-center justify-center bg-cyan-50 rounded-lg mb-5">
              <i className="ri-focus-3-line text-cyan-600 text-2xl"></i>
            </div>
            <h3 className="text-gray-900 font-bold text-lg uppercase tracking-wide mb-3">Mission &amp; Goals</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Our mission is to build our reputation for integrity, excellence, and leadership as one of the finest engineering and contracting organizations by:
            </p>
            <ul className="space-y-3">
              {missionPoints.map((point, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-gray-600">
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-500 mt-1.5 shrink-0"></span>
                  {point}
                </li>
              ))}
            </ul>
          </div>

          {/* Company Ethos */}
          <div className="bg-white rounded-lg p-8 border border-gray-100">
            <div className="w-12 h-12 flex items-center justify-center bg-cyan-50 rounded-lg mb-5">
              <i className="ri-heart-line text-cyan-600 text-2xl"></i>
            </div>
            <h3 className="text-gray-900 font-bold text-lg uppercase tracking-wide mb-3">Company Ethos</h3>
            <p className="text-gray-500 text-sm leading-relaxed">
              Our company ethos revolves around being regarded by all our stakeholders as being <strong className="text-gray-700">honorable and conscientious</strong>.
            </p>
            <div className="mt-6 p-4 bg-cyan-50 rounded-lg border-l-4 border-cyan-500">
              <p className="text-cyan-800 text-sm font-medium italic">
                "We do what we say, and we say what we do — with full accountability to every client, partner, and team member."
              </p>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {["Integrity", "Accountability", "Professionalism", "Excellence"].map((v) => (
                <div key={v} className="flex items-center gap-2 text-xs text-gray-600">
                  <i className="ri-checkbox-circle-line text-cyan-500"></i>
                  {v}
                </div>
              ))}
            </div>
          </div>

          {/* Our Policy */}
          <div className="bg-white rounded-lg p-8 border border-gray-100">
            <div className="w-12 h-12 flex items-center justify-center bg-cyan-50 rounded-lg mb-5">
              <i className="ri-shield-check-line text-cyan-600 text-2xl"></i>
            </div>
            <h3 className="text-gray-900 font-bold text-lg uppercase tracking-wide mb-3">Our Policy</h3>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-px h-10 bg-cyan-400"></div>
              <p className="text-cyan-700 text-xl font-extrabold italic">"Honesty is the best Policy"</p>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              At ISMAN, transparency in every engagement is non-negotiable. We believe that long-term relationships are built on trust, clear communication, and consistent delivery — no shortcuts, no hidden costs.
            </p>
            <div className="mt-6 space-y-2">
              {["Transparent pricing", "Clear communication", "On-time delivery", "Full documentation"].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5 text-sm text-gray-600">
                  <span className="w-5 h-5 flex items-center justify-center bg-cyan-100 rounded-full shrink-0">
                    <i className="ri-check-line text-cyan-600 text-xs"></i>
                  </span>
                  {item}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
